// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:32
import { DeferredAssignment_abstract } from './../abstract/SagaSchema/DeferredAssignment_abstract';
export class DeferredAssignment extends DeferredAssignment_abstract {}
